import Vue from 'vue'
import ElementUi from 'element-ui'
import '@/styles/element-ui.scss'

Vue.use(ElementUi)
